module.exports = __webpack_public_path__ + "media/images/bg-W-e659ed62fca5f460a3ee662c2d514159.svg";